import ReactDOM from 'react-dom';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import customHistory from '@shared/helper/history';
import reportWebVitals from './reportWebVitals';
import App from './App';
import i18n from './i18n';

ReactDOM.render(
	<HistoryRouter history={customHistory}>
		<I18nextProvider i18n={i18n}>
			<HelmetProvider>
				<RecoilRoot>
					<App />
					<RecoilNexus />
				</RecoilRoot>
			</HelmetProvider>
		</I18nextProvider>
	</HistoryRouter>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
